import CssBaseline from '@mui/material/CssBaseline';

import LinearProgress from '@mui/material/LinearProgress';
import { StyledEngineProvider } from '@mui/material/styles';
import { lazy, Suspense, useMemo } from 'react';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';

const AppTheme = lazy(() => import('./theme/AppTheme'));

// Dynamically import AppTheme to reduce initial bundle size

export const MuiBoostrap = ({ children }) => {
  const { i18n, } = useTranslation();
  const actualLanguage = useMemo(() => {
    let language = i18n.language;
    if (language?.indexOf('-') > -1) {
      language = language.split('-')[0];
    }
    return language || 'es';
  }, [i18n.language]);
  return (
      <StyledEngineProvider injectFirst>
        <Suspense fallback={<LinearProgress />}>
          <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={actualLanguage}>
            <AppTheme>
              <CssBaseline />
              {children}
            </AppTheme>
          </LocalizationProvider>
        </Suspense>
      </StyledEngineProvider>
  );
};

export default MuiBoostrap;
